import { render, staticRenderFns } from "./resubir-comprobante.vue?vue&type=template&id=2b5640f6"
import script from "./resubir-comprobante.vue?vue&type=script&lang=js"
export * from "./resubir-comprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports